import type { SvgIconComponent } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/EditOutlined";
import ViewIcon from "@mui/icons-material/VisibilityOutlined";
import { Button, Card, Divider, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  title: string;
  Icon: SvgIconComponent;
  hideView?: boolean;
  onView?: () => void;
  onEdit?: () => void;
}

const InvestorCommunicationSettingsTile = ({
  title,
  Icon,
  hideView,
  onView,
  onEdit,
  children,
}: PropsWithChildren<Props>) => (
  <Card variant="outlined">
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "space-between", px: 2, py: 1.5 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Icon color="action" />
        <Typography variant="subtitle1">{title}</Typography>
      </Stack>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        {!hideView && (
          <Button variant="outlined" color="secondary" startIcon={<ViewIcon />} disabled={!onView} onClick={onView}>
            View
          </Button>
        )}
        <Button variant="outlined" color="secondary" startIcon={<EditIcon />} disabled={!onEdit} onClick={onEdit}>
          Edit
        </Button>
      </Stack>
    </Stack>
    <Divider />
    <Stack sx={{ px: 2, py: 1.5 }}>{children}</Stack>
  </Card>
);

export default InvestorCommunicationSettingsTile;
